/**
 * Handles reporting front-end errors to an external monitoring service.
 * */

import * as Sentry from '@sentry/react';
import { AppError } from '../../shared/types/appError';


export function init() {
    Sentry.init({
        dsn: 'https://1f0b0856835eadfe22d7e1e0b1bccc90@o4506341886590976.ingest.sentry.io/4506341892096000',

        environment: import.meta.env.APP_ENV,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration()
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // tracesSampleRate: 1.0,

        // Capture Replays of sessions with an error
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 1.0,

        // Make sure that adblockers don't block the Sentry script, by routing requests through the back-end
        tunnel: '/sentry',

        // Avoid reporting, when dontReport is true for the given error
        beforeSend(event, hint) {
            let error = hint.originalException;
            while (error instanceof Error) { // Walk the cause chain
                if (error instanceof AppError && error.dontReport) return null; // suppress
                error = (error as { cause?: unknown }).cause;
            }
            return event;
        },
    });
}

export function isEnabled(): boolean {
    // return true;
    return import.meta.env.APP_ENV === 'production' || import.meta.env.APP_ENV === 'staging';
}

export function createReactErrorHandler() {
    return Sentry.reactErrorHandler();
}

export function reportError(error: any) {
    const finalError = error instanceof Error ? error : new Error(error);
    console.log('Reporting error to Sentry:', finalError);
    Sentry.captureException(finalError);
}
